import { HeartFilled, HeartOutlined } from "@ant-design/icons"
import { motion } from "framer-motion"

export interface IFavoriteIconProps {
    isFavorite?: boolean
    onClick?: () => void
}
export const FavoriteIcon = ({ isFavorite, onClick }: IFavoriteIconProps) => {
    return (
        <article>

            {isFavorite ?
                <motion.figcaption
                    whileTap={{ scale: 0.8, rotateZ: 30, rotateX: 30 }}
                    animate={{ scrollBehavior: 'smooth' }}
                >
                    <HeartFilled onClick={() => onClick?.()} className='m-track__favorite m-track__favorite--selected' />
                </motion.figcaption>
                :
                <motion.article
                    whileTap={{ scale: 1.4, rotateY: 30 }}
                    animate={{ scrollBehavior: 'smooth' }}
                    transition={{ ease: "easeOut", duration: 0.2 }}
                // animate={{ rotateX: 360 }}
                >
                    <HeartOutlined onClick={() => onClick?.()} className='m-track__favorite' />
                </motion.article>

            }

        </article>
    )
}
